<template>
    <b-form-row>
        <tarefa-aprovacao-almoxarifado-modal :isVisualizacao="isVisualizacao"
            v-if="showTarefaAprovacaoAlmoxarifadoModal" :devolucao="devolucao" :tarefa="selectedItem"
            uri="/aprovacao-almoxarifado" @close="fecharTarefaAprovacaoAlmoxarifado"
            :prefix="prefix + title + ' > '"></tarefa-aprovacao-almoxarifado-modal>

        <tarefa-aprovacao-solicitante-modal v-if="showTarefaAprovacaoSolicitanteModal" :isVisualizacao="isVisualizacao"
            :prefix="prefix + title + ' > '" :devolucao="devolucao" :tarefa="selectedItem" uri="/aprovacao-solicitante"
            @tarefaAprovacaoFinalizado="fecharTarefaAprovacaoSolicitante">
        </tarefa-aprovacao-solicitante-modal>

        <b-modal id="toggleDevolucaoModal" v-model="showModal" size="xl" :title="prefix + title" @close="closeModal"
            @hidden="closeModal" hide-footer>
            <b-card bg-variant="light">
                <b-card>
                    <div>
                        <span style="font-size: 16px">
                            <strong>Nº Devolução:</strong> {{ devolucao.id }}<br />
                            <strong>Solicitante:</strong>
                            {{ devolucao.departamento.descricao }} <br />
                            <strong>Status:</strong> {{ devolucao.status.descricao }}<br />
                        </span>
                    </div>
                </b-card>

                <b-tabs content-class="mt-3">
                    <b-tab title="Tarefas" active>
                        <b-table id="detalhe-tarefas" responsive class="mt-2" small :items="tarefas"
                            :fields="fieldsTarefas" :busy="this.busy" show-empty>
                            <template v-slot:cell(detalheTarefa)="row">

                                <b-button id="iniciar" v-if="verificaPrivilegioTarefa(row.item) && row.item.status.id === 127"
                                    pill size="sm" variant="primary" title="Iniciar a tarefa atual..."
                                    @click="iniciarTarefa(row.item)">
                                    <b-icon icon="file-earmark-play" />
                                </b-button>
                                <b-button v-if="
                                    verificaPrivilegioTarefa(row.item) &&
                                    row.item.tipoTarefaDevolucao.id === 10 && row.item.status.id !== 127 && row.item.status.id !== 129
                                " pill size="sm" variant="primary" title="Continuar a tarefa atual..."
                                    @click="abrirModalAlmoxarifadoModal(row.item)">
                                    <b-icon icon="file-earmark-arrow-up" />
                                </b-button>

                                <b-button v-if="
                                    verificaPrivilegioTarefa(row.item) &&
                                    row.item.tipoTarefaDevolucao.id === 13 && row.item.status.id !== 127 && row.item.status.id !== 129
                                " pill size="sm" variant="primary" title="Continuar a tarefa atual..."
                                    @click="abrirModalSolicitanteModal(row.item)">
                                    <b-icon icon="file-earmark-arrow-up" />
                                </b-button>


                                <b-button v-b-tooltip.hover.bottom="'Visualizar a tarefa atual...'"
                                    v-if="row.item.status.id == 129" :id="'historico' + row.index" size="sm"
                                    variant="primary" @click="detalharTarefa(row.item)" pill>
                                    <b-icon icon="clock" />
                                </b-button>
                            </template>

                            <template v-slot:cell(tipoTarefaDevolucao)="row">

                                <span v-b-tooltip.hover.bottom="'Detalhes da tarefa atual...'"
                                    style="color:blue; cursor: pointer;" @click="detalharTarefa(row.item)">{{
                                        row.item.tipoTarefaDevolucao.descricao }}</span>

                            </template>
                            <template #empty>
                                <p>Nenhum registro encontrado</p>
                            </template>

                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>
                            <template #cell(devolucaoId)>
                                <span>{{ devolucao.id }}</span>
                            </template>

                            <template #cell(solicitante)>
                                <span>{{ devolucao.departamento.descricao }}</span>
                            </template>
                        </b-table>
                    </b-tab>
                    <b-tab title="Itens">
                        <b-table id="t-itens" responsive class="mt-2" small :items="itens" :fields="fieldsItens"
                            :busy="this.busy" show-empty>
                            <template #empty>
                                <p>Nenhum registro encontrado</p>
                            </template>

                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>
                        </b-table>
                    </b-tab>
                </b-tabs>
            </b-card>
        </b-modal>
    </b-form-row>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import ConfirmMixin from "@/core/mixins/confirm"
import Formatters from "@/core/mixins/formatters"
import Resource from "@/core/mixins/resource"
import moment from "moment"
import { ListResourceMixin } from "@/core/mixins/resource"
import { FormResourceMixin } from "@/core/mixins/resource"
import TarefaAprovacaoAlmoxarifadoModal from "./TarefaAprovacaoAlmoxarifadoModal.vue"
import TarefaAprovacaoSolicitanteModal from "./TarefaAprovacaoSolicitanteModal.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"

export default {
    mixins: [
        Formatters,
        ConfirmMixin,
        Resource.FormResourceMixin,
        ListResourceMixin,
        FormResourceMixin,
    ],
    components: {
        TarefaAprovacaoAlmoxarifadoModal,
        TarefaAprovacaoSolicitanteModal,
    },

    props: {
        devolucao: {
            type: Object,
            required: true,
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Detalhes",
        },
    },

    data() {
        return {
            isVisualizacao: false,
            showTarefaAprovacaoSolicitanteModal: false,
            selectedItem: {},
            showTarefaAprovacaoAlmoxarifadoModal: false,
            busy: false,
            showModal: true,
            itens: [],
            tarefas: [],
        }
    },

    beforeMount() {
        this.$service = new ResourceService(`api/devolucoes/details/itens`)
        this.$serviceTarefa = new ResourceService(`api/devolucoes/details/tarefa`)
        this.$serviceTarefaSave = new ResourceService(`/api/tarefadevolucao`)
    },

    mounted() {
        this.load()
    },

    computed: {
        fieldsTarefas() {
            return [
                { key: "id", label: "Nº" },
                { key: "devolucaoId", label: "Nº Devolução" },
                { key: "status.descricao", label: "Status" },
                { key: "solicitante", label: "Solicitante" },
                { key: "destino", label: "Destino" },
                { key: "responsavel", label: "Responsável" },
                { key: "tipoTarefaDevolucao", label: "Tarefa" },
                {
                    key: "dataCriacao",
                    label: "Data",
                    formatter: value => moment(value).format("DD/MM/yyyy HH:mm"),
                },
                { key: "detalheTarefa", label: " " },
            ]
        },

        fieldsItens() {
            return [
                {
                    key: "almoxarifadoProduto.numero",
                    label: "Número",
                    tdStyle: "width: 15%",
                    thStyle: "width: 15%",
                },
                {
                    key: "almoxarifadoProduto.produto.descricaoResumida",
                    label: "Produto",
                },
                {
                    key: "almoxarifadoProduto.almoxarifado.descricao",
                    label: "Almoxarifado",
                    tdStyle: "width: 25%",
                    thStyle: "width: 25%",
                },
                {
                    key: "quantidadeDevolvida",
                    label: "Devolvido",
                    tdStyle: "width: 10%",
                    thStyle: "width: 10%",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    key: "quantidadeAprovado",
                    label: "Aprovado",
                    tdStyle: "width: 10% ",
                    thStyle: "width: 10%",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
            ]
        },
    },
    methods: {
        verificaPrivilegioTarefa(tarefa) {

            if (tarefa.tipoTarefaDevolucao.id == 13)
                return verificaPrivilegio(PrivilegiosEnum.DEVOLUCAO_RECEBER)
            else
                return verificaPrivilegio(PrivilegiosEnum.DEVOLUCAO_APROVAR);
        },

        async iniciarTarefa(item) {
            let response = await this.$confirm(
                `Deseja iniciar esta tarefa (${item.tipoTarefaDevolucao.descricao}) ?`
            )
            if (response) {
                item.status.id = 128
                item.status.descricao = "Em andamento"
                this.$serviceTarefaSave.save(item)
                this.isVisualizacao = false
                if (
                    item.tipoTarefaDevolucao.descricao === "Aprovação do Almoxarifado"
                ) {
                    this.abrirModalAlmoxarifadoModal(item)
                }
                if (item.tipoTarefaDevolucao.descricao === "Recebimento") {
                    this.abrirModalSolicitanteModal(item)
                }
            } else {
                return
            }
        },

        detalharTarefa(item) {
            this.isVisualizacao = true
            if (item.tipoTarefaDevolucao.id == 10) {
                this.abrirModalAlmoxarifadoModal(item)
            }

            if (
                item.tipoTarefaDevolucao.id == 11 ||
                item.tipoTarefaDevolucao.id == 13
            ) {
                this.abrirModalSolicitanteModal(item)
            }
        },
        abrirModalSolicitanteModal(item) {
            this.selectedItem = item
            this.showTarefaAprovacaoSolicitanteModal = true
        },

        abrirModalAlmoxarifadoModal(item) {
            this.selectedItem = item
            this.showTarefaAprovacaoAlmoxarifadoModal = true
        },

        async load() {
            this.busy = true

            Promise.all([
                this.$service.findById(this.devolucao.id),
                this.$serviceTarefa.findById(this.devolucao.id),
            ]).then(response => {
                this.itens = response[0].data
                this.tarefas = response[1].data

                this.busy = false
            })
        },

        fecharTarefaAprovacaoAlmoxarifado() {
            this.showTarefaAprovacaoAlmoxarifadoModal = false;
        },

        fecharTarefaAprovacaoSolicitante() {
            this.showTarefaAprovacaoSolicitanteModal = false;
        },

        closeModal() {
            this.$emit("close")
        },

        formatDate(value) {
            return moment(value).format("DD/MM/yyyy")
        },
    },
}
</script>
